import { useHirerAuth } from '@seek/hirer-auth-react';
import { useAccountContext } from '@seek/hirer-graphql-react';

export const getSeekId = () => {
  if (typeof window !== 'undefined') {
    const localStorageIsAvailable = window && window.localStorage;
    return localStorageIsAvailable
      ? window.localStorage.getItem('adv-account-selection-seek-id')
      : '99999999';
  }
};

export const getAccountId = () => {
  if (typeof window !== 'undefined') {
    const localStorageIsAvailable = window && window.localStorage;
    return localStorageIsAvailable
      ? window.localStorage.getItem('adv-account-selection-billing-id')
      : '99999999';
  }
};

export const useAccountIds = () => {
  const { authenticated } = useHirerAuth();
  const { accountContext } = useAccountContext({
    skip: !authenticated,
  });

  return {
    userId: accountContext?.currentUser?.id || '',
    billingId: accountContext?.currentAdvertiser?.billingId || '',
  };
};
